import { render, staticRenderFns } from "./ObjectConifg.vue?vue&type=template&id=5d755917&scoped=true&"
import script from "./ObjectConifg.vue?vue&type=script&lang=js&"
export * from "./ObjectConifg.vue?vue&type=script&lang=js&"
import style0 from "./ObjectConifg.vue?vue&type=style&index=0&id=5d755917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d755917",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d755917')) {
      api.createRecord('5d755917', component.options)
    } else {
      api.reload('5d755917', component.options)
    }
    module.hot.accept("./ObjectConifg.vue?vue&type=template&id=5d755917&scoped=true&", function () {
      api.rerender('5d755917', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/ObjectConifg.vue"
export default component.exports